import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { HiEye, HiEyeOff } from "react-icons/hi";
import Modal from "../../ui/Modal";
import FormRow from "../../ui/FormRow";
import { useAddUser } from "../user/useAddUser";

const AddUserModal = ({ onClose, isOpen }) => {
    const { createUser, isCreating } = useAddUser();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const { register, handleSubmit, formState: { errors }, watch } = useForm({
        defaultValues: {
            role: "user"
        }
    });

    const onSubmit = (data) => {
        const formData = new FormData();
        formData.append("name", data.name);
        formData.append("email", data.email);
        formData.append("password", data.password);
        formData.append("role", data.role);

        if (data.avatar && data.avatar[0]) {
            formData.append("avatar", data.avatar[0]);
        }

        createUser(formData, {
            onSuccess: () => {
                onClose();
            }
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Add New User">
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
                <FormRow lable="Name" error={errors.name?.message}>
                    <input
                        type="text"
                        className="input-bordered input w-full bg-slate-900/50 text-white placeholder-slate-400 border-slate-700 focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                        placeholder="John Doe"
                        {...register("name", {
                            required: "Name is required",
                            minLength: { value: 2, message: "Name must be at least 2 characters" }
                        })}
                    />
                </FormRow>

                <FormRow lable="Email" error={errors.email?.message}>
                    <input
                        type="email"
                        className="input-bordered input w-full bg-slate-900/50 text-white placeholder-slate-400 border-slate-700 focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                        placeholder="admin@portfolio.com"
                        {...register("email", {
                            required: "Email is required",
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address"
                            }
                        })}
                    />
                </FormRow>

                <FormRow lable="Password" error={errors.password?.message}>
                    <div className="relative">
                        <input
                            type={showPassword ? "text" : "password"}
                            className="input-bordered input w-full bg-slate-900/50 text-white placeholder-slate-400 border-slate-700 focus:border-sky-500 focus:ring-1 focus:ring-sky-500 pr-10"
                            placeholder="••••••••"
                            {...register("password", {
                                required: "Password is required",
                                minLength: { value: 6, message: "Password must be at least 6 characters" }
                            })}
                        />
                        <button
                            type="button"
                            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-white"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <HiEyeOff className="h-5 w-5" /> : <HiEye className="h-5 w-5" />}
                        </button>
                    </div>
                </FormRow>

                <FormRow lable="Confirm Password" error={errors.confirmPassword?.message}>
                    <div className="relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            className="input-bordered input w-full bg-slate-900/50 text-white placeholder-slate-400 border-slate-700 focus:border-sky-500 focus:ring-1 focus:ring-sky-500 pr-10"
                            placeholder="••••••••"
                            {...register("confirmPassword", {
                                required: "Please confirm your password",
                                validate: (val) => {
                                    if (watch('password') !== val) {
                                        return "Passwords do not match";
                                    }
                                }
                            })}
                        />
                        <button
                            type="button"
                            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-white"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? <HiEyeOff className="h-5 w-5" /> : <HiEye className="h-5 w-5" />}
                        </button>
                    </div>
                </FormRow>

                <FormRow lable="Profile Image" error={errors.avatar?.message}>
                    <input
                        type="file"
                        accept="image/*"
                        className="file-input file-input-bordered file-input-primary w-full bg-slate-900/50 text-white border-slate-700"
                        {...register("avatar")}
                    />
                </FormRow>

                <FormRow lable="Role">
                    <select
                        className="select-bordered select w-full bg-slate-900/50 text-white border-slate-700 focus:border-sky-500 focus:ring-1 focus:ring-sky-500"
                        {...register("role")}
                    >
                        <option value="user">User</option>
                        <option value="editor">Editor</option>
                        <option value="admin">Admin</option>
                        <option value="super_admin">Super Admin</option>
                    </select>
                </FormRow>

                <div className="mt-4 flex justify-end gap-2">
                    <button
                        type="button"
                        className="btn-ghost btn"
                        onClick={onClose}
                        disabled={isCreating}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn-primary btn"
                        disabled={isCreating}
                    >
                        {isCreating ? "Creating..." : "Create User"}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default AddUserModal;
